import React, { useState, useEffect } from "react";
import Header from "../include/header";
import Footer from "../include/footer";
import LeftPanel from "../include/leftpanel";
import axios from "axios";
import Global from "../../APIConfig";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AuthUser from "../../AuthUser";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import MainLoader from "../Loaders/MainLoader";
import ListLoader from "../Loaders/ListLoader";
import CopyToClipboard from 'react-copy-to-clipboard';

function Weightdiscrepancylist(){
    const location = useLocation();    
    let navigate = useNavigate();
    const{headers1,headers2,logout}=AuthUser();
    const [list, setList] = useState([]);
    const [Loading, setLoading] = useState(true);
    const [Subloading, setSubloading] = useState(false);
    const [SearchType, setSearchType] = useState('Any');
    const [SearchVal, setSearchVal] = useState('');
    const [currentPage, setCurrentPage] = useState(1);    
    const [lastPage, setLastPage] = useState(1); // Total number of pages
    const [nextPageUrl, setNextPageUrl] = useState(null);
    const [prevPageUrl, setPrevPageUrl] = useState(null);
    const pageRangeDisplayed = 2;

     useEffect(()=>{            
    
        const query = new URLSearchParams(location.search);
        const page = query.get('page') ? parseInt(query.get('page'), 10) : 1;
        const search = query.get('search') || '';
        setCurrentPage(page);
        setSearchVal(search);
        GetHubList(page,search);

    },[location.search]);
    // useEffect(()=>{
    //     GetHubList();
    // },[]);
    const items = JSON.parse(localStorage.getItem('user'));
    const GetHubList=(page=1,type,val)=>{
        setSubloading(true);
        setSearchVal(val);
        axios({
            method: 'post',
            url: Global.baseUrl+'Fetchadminweightdiscrepancylist',
            headers:headers1,
            data: {
                user_id:items.uniqueid,
                SearchType:SearchType,
                SearchVal:SearchVal,
                page:page,
            }
          })
          .then(function (response) {
            if(response.data.status == 200)
            {
                var data=response.data.value.data;
                setList(data);
                setCurrentPage(response.data.value.current_page);
                setLastPage(response.data.value.last_page);
                setNextPageUrl(response.data.value.next_page_url); // URL for next page
                setPrevPageUrl(response.data.value.prev_page_url); // URL for previous page
            }
            else
            {
                setList();
            }
            setSubloading(false);
            setLoading(false);
          })
          .catch(function (error) {
            if(error.response.status==401){
                toast.error(error.response.statusText);
                logout();
                navigate('/');
                window.location.reload();
            }
            setSubloading(false);
            setLoading(false);
            // console.log(error);
          });
    }
    const SearchCust=(e)=>{
        setSearchVal(e);
        GetHubList();
    }

     // Update the URL and fetch the data for the selected page
    const handlePageChange = (pageNumber) => {
        const query = new URLSearchParams(location.search);
        query.set('page', pageNumber);
        navigate(`?${query.toString()}`);
    };

    
    // Handle Previous button click
    const handlePreviousPage = () => {
        if (prevPageUrl) {
            handlePageChange(currentPage - 1);
        }
    };

    // Handle Next button click
    const handleNextPage = () => {
        if (nextPageUrl) {
            handlePageChange(currentPage + 1);
        }
    };

    // Create pagination items for each page, showing a limited number of page numbers with ellipses
    const renderPageNumbers = () => {
        const pages = [];

        // Always show the first page
        if (currentPage > pageRangeDisplayed + 1) {
            pages.push(
                <li key={1} className="page-item">
                <button className="page-link" onClick={() => handlePageChange(1)}>1</button>
                </li>
            );
            pages.push(<li key="start-ellipsis" className="page-item disabled"><span className="page-link">...</span></li>);
        }

        // Show the range of pages around the current page
        for (let i = Math.max(1, currentPage - pageRangeDisplayed); i <= Math.min(lastPage, currentPage + pageRangeDisplayed); i++) {
            pages.push(
                <li key={i} className={`page-item ${i === currentPage ? 'active' : ''}`}>
                <button className="page-link" onClick={() => handlePageChange(i)}>
                    {i}
                </button>
                </li>
            );
        }

        // Always show the last page
        if (currentPage < lastPage - pageRangeDisplayed) {
            pages.push(<li key="end-ellipsis" className="page-item disabled"><span className="page-link">...</span></li>);
            pages.push(
                <li key={lastPage} className="page-item">
                <button className="page-link" onClick={() => handlePageChange(lastPage)}>{lastPage}</button>
                </li>
            );
        }

        return pages;
    };
    return(
        <>
        <LeftPanel/>
        <main className='home-section'>
            <Header/>
            <ToastContainer/>
            {Loading==true?<MainLoader/>:
            <>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                <div className="d-block mb-4 mb-md-0">
                    <nav aria-label="breadcrumb" className="d-none d-md-inline-block">
                        <ol className="breadcrumb breadcrumb-dark breadcrumb-transparent">
                            <li className="breadcrumb-item">
                                <a href="#">
                                <i className="bx bx-home text-primary-400 fs-6"></i>
                                </a>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">Weight Discrepancy</li>
                        </ol>
                    </nav>
                    <div className="d-flex justify-content-between">
                        <div className="">
                            <button className="btn btn_nav btn-sm" type="button">
                            <i className="bx bx-arrow-back "></i>
                            </button>
                        </div>
                        <div className="ps-2 ">
                            <h2 className="h4">All Weight Discrepancy</h2>
                        </div>
                    </div>
                </div>
            </div>
            
            <section className="data_table">
                <div className="card card-body border-0 shadow table-wrapper table-responsive ">
                    <table className="table table-hover">
                        <thead>
                            <tr>
                                <th className="border-gray-200">Weight Applied Date</th>
                                <th className="border-gray-200">Order No.</th>
                                <th className="border-gray-200">AWB No.</th>
                                <th className="border-gray-200">Entered Weight</th>
                                <th className="border-gray-200">Weight Charges</th>
                                <th className="border-gray-200">Applied weight</th>
                                <th className="border-gray-200">Final Weight Charges</th>
                                <th className="border-gray-200">Difference</th>
                            </tr>
                        </thead>
                        {Subloading==true && <ListLoader/>}
                        {list!=undefined && list.length>0 && Subloading==false ?
                        <tbody>
                            {list.map((item,index)=>{
                                return(
                                    <tr key={index}>
                                        <td><span className="fw-normal text-capitalize">{item.entry_date}</span></td>
                                        <td><span className="fw-normal text-capitalize">{item.order_no}</span></td>
                                        <td><span className="fw-normal text-capitalize">{item.awb_no}</span></td>
                                        <td><span className="fw-normal text-capitalize">{item.entered_weight}KG {item.entered_height}x{item.entered_width}x{item.entered_length} CM</span></td>
                                        <td><span className="fw-normal text-capitalize">{item.entred_weight_price}</span></td>
                                        <td><span className="fw-normal text-capitalize">{item.new_weight}KG {item.new_height}x{item.new_width}x{item.new_length} CM</span></td>
                                        <td><span className="fw-normal text-capitalize">{item.new_weight_price}</span></td>
                                        <td><span className="fw-normal text-capitalize">{item.price_difference}</span></td>
                                    </tr>
                                );
                            })}                     
                        </tbody>
                        :
                        <tbody><tr><td colSpan={8} className="text-center text-danger"> Record Not Found </td></tr></tbody>
                        }
                    </table>
                    
                </div>
            </section>
            <div className="card-footer px-3 border-0 d-flex flex-column flex-lg-row align-items-center justify-content-between">
                <nav aria-label="Page navigation example">
                    <ul className="pagination mb-0">
                        {/* Previous Button */}
                        <li className={`page-item ${!prevPageUrl ? 'disabled' : ''}`}>
                            <button className="page-link" onClick={handlePreviousPage} disabled={!prevPageUrl}>
                            Previous
                            </button>
                        </li>

                        {/* Page Numbers */}
                        {renderPageNumbers()}

                        {/* Next Button */}
                        <li className={`page-item ${!nextPageUrl ? 'disabled' : ''}`}>
                            <button className="page-link" onClick={handleNextPage} disabled={!nextPageUrl}>
                            Next
                            </button>
                        </li>
                    </ul>
                </nav>
                {/* <div className="fw-normal small mt-4 mt-lg-0">Showing <b>5</b> out of <b>25</b> entries</div> */}
            </div>
            </>
            }
            <Footer/>
        </main>
        </>

    );
}
export default Weightdiscrepancylist;